module.exports = __webpack_public_path__ + "static/img/about-b.6c15a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-b.png
// module id = DSJY
// module chunks = 1